import Enumerable from "linq";
import { IDocumentAlert } from "../IDocumentAlert";
import { IItem } from "../items";
import { AbstractItemsValidator } from "./AbstractItemsValidator";

export abstract class AbstractItemValidator extends AbstractItemsValidator {
  protected validateItems(items: IItem[], index: number): IDocumentAlert[] {
    return Enumerable.from(items)
      .select(i => this.validateItem(i, index))
      .aggregate([] as IDocumentAlert[], (s, a) => s.concat(a));
  }

  protected abstract validateItem(item: IItem, itemSetId: number): IDocumentAlert[];
}
